import React, { useCallback, useEffect, useState } from 'react';
import {
  ArrowDown, ArrowUp, Building2, Cpu, Eye, EyeOff, Gamepad2,
  Activity, Home, LayoutDashboard, LogOut, Mail, Monitor, Pause, Play, Plus, Radio, RotateCcw, Save, Settings2, ShieldAlert, UserRound, Wallet, X,
} from "lucide-react";
import "./web/workspace.css";
import Brand from "./web/Brand.jsx";

const LOGO_DATA_URI = "data:image/png;base64,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";

const API_BASE = typeof window !== "undefined" && window.EA_API_BASE
  ? window.EA_API_BASE.replace(/\/$/, "")
  : "/v1";
const TOKEN_KEY = "ea-remote-token";

const DEFAULT_SETTINGS = {
  comment: "CT SARJANA FX",
  baseLot: "0.01", maxLayers: "100", stepPoints: "400", lotIncrement: "0.02",
  tpPerSide: "100", tpTotal: "10", useDynamicTP: true,
  tpLevels: {
    "1-3": "10", "4-6": "20", "7-9": "30", "10-20": "50",
    "21-40": "50", "41-60": "50", "61-80": "50", "81-100": "50",
  },
  useStopLoss: false, slPoints: "0", useDailyTP: true, dailyTP: "1200",
  maxSpread: "9999", slippage: "0", minSecBetweenOps: "0",
  allowBothSides: true, allowBuy: true, allowSell: true,
  autoStart: true, startMode: "START_BOTH",
};

const COMMANDS = {
  CMD_CLOSE_ALL: "Close All / Reset",
  CMD_CLOSE_BUY: "Close Buy",
  CMD_CLOSE_SELL: "Close Sell",
  CMD_BUY_NOW: "Buy Now",
  CMD_SELL_NOW: "Sell Now",
  CMD_STOP: "Stop (entry dimatikan)",
  CMD_PANIC_STOP: "Panic Stop (tutup semua + entry dimatikan)",
  CMD_START: "Start (lanjutkan entry)",
};

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=JetBrains+Mono:wght@400;500;600&family=Inter:wght@400;500;600&display=swap');
*{box-sizing:border-box}body{margin:0}.app{--bg:#0a0e14;--panel:#11161f;--panel2:#161c27;--border:#232b38;--text:#e7ecf3;--dim:#8a94a6;--teal:#2bd9b9;--amber:#f2994a;--red:#e5484d;--blue:#1e9e5c;background:var(--bg);min-height:100vh;color:var(--text);padding:16px 16px 40px}.wrap{max-width:460px;margin:auto}.card,.panel{background:var(--panel);border:1px solid var(--border);border-radius:16px;padding:16px}.panel{margin-bottom:14px}.header{background:linear-gradient(135deg,#0b6e3d,#2fbf71);border-radius:18px;padding:20px 18px;display:flex;justify-content:space-between;align-items:flex-start;gap:10px}.brand{display:flex;gap:10px;min-width:0}.logo{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.9);display:grid;place-items:center;flex:none;padding:4px}.logo img{width:100%;height:100%;object-fit:contain}.title,h1,h2,h3,button{font-family:'Space Grotesk',sans-serif}.title{font-size:17px;font-weight:700}.account-pill{display:inline-block;margin-top:8px;background:#00000047;color:#d6f5e3;font:11px 'JetBrains Mono';padding:4px 10px;border-radius:999px;max-width:220px}.tabs{display:flex;gap:8px;background:var(--panel);padding:6px;border-radius:14px;margin-top:14px;border:1px solid var(--border)}.tabs button{flex:1}.tab{display:flex;align-items:center;justify-content:center;gap:8px;padding:11px;border:0;border-radius:10px;background:transparent;color:var(--dim);font-weight:600}.tab.active{background:var(--blue);color:white}.section{margin-top:18px}.section h2{font-size:20px;margin:4px 0 2px}.muted{color:var(--dim);font:13px Inter,sans-serif}.status{display:inline-flex;align-items:center;gap:7px;margin-top:12px;padding:6px 12px;border-radius:999px;font:600 12px 'Space Grotesk'}.status.online{color:var(--teal);background:#2bd9b91f}.status.offline{color:var(--red);background:#e5484d1f}.dot{width:10px;height:10px;border-radius:50%;background:currentColor;flex:none}.status.online .dot{animation:pulseRing 1.8s ease-out infinite}@keyframes pulseRing{0%{box-shadow:0 0 0 0 currentColor}70%{box-shadow:0 0 0 8px transparent}100%{box-shadow:0 0 0 0 transparent}}.stat-card{background:var(--panel2);border:1px solid var(--border);border-radius:14px;padding:14px 16px}.stat-label{color:var(--dim);font:13px Inter;margin-bottom:6px}.stat-value{font:700 22px 'Space Grotesk'}.meta{margin-top:12px;color:var(--dim);font:12.5px Inter;display:flex;gap:7px;align-items:center}.fine{margin-top:10px;padding-top:8px;border-top:1px dashed var(--border);color:var(--dim);font:10.5px 'JetBrains Mono'}.command-grid,.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.command-grid{margin-top:12px}.cmd{border-radius:14px;padding:16px 10px;cursor:pointer}.cmd.wide{width:100%;margin-top:12px}.cmd:disabled,.primary:disabled{opacity:.55;cursor:not-allowed}.cmd-title{font-weight:700;font-size:14px}.cmd-sub{font:11.5px Inter;margin-top:3px;color:var(--dim)}.cmd.solid .cmd-title,.cmd.solid .cmd-sub{color:white}.cmd.solid .cmd-sub{opacity:.85}.panel-title{display:flex;align-items:center;gap:8px;margin-bottom:14px}.panel-title h3{font-size:15px;margin:0}.field{display:block}.field-label{color:var(--dim);font:12px Inter;margin-bottom:6px}.field-wrap{position:relative}.field input,.field select,.account-select{width:100%;background:var(--panel2);border:1px solid var(--border);border-radius:10px;padding:10px 12px;color:var(--text);font:14px 'JetBrains Mono';outline:none}.field input:focus,.field select:focus{border-color:var(--blue)}.field input[readonly]{color:var(--dim)}.suffix{position:absolute;right:12px;top:50%;transform:translateY(-50%);color:var(--dim);font:12px 'JetBrains Mono'}.field input.has-reveal{padding-right:44px}.reveal{position:absolute;right:5px;top:50%;transform:translateY(-50%);width:34px;height:34px;padding:0;display:grid;place-items:center;background:none;border:0;border-radius:8px;color:var(--dim);cursor:pointer}.reveal:hover{color:var(--text)}.reveal:focus-visible{outline:2px solid var(--blue);outline-offset:-2px}.toggle{width:100%;display:flex;justify-content:space-between;align-items:center;background:none;border:0;padding:4px 0;color:var(--text);font:14px Inter;cursor:pointer}.switch{width:42px;height:24px;border-radius:999px;background:var(--border);position:relative;flex:none}.switch.on{background:var(--teal)}.switch:after{content:'';position:absolute;top:3px;left:3px;width:18px;height:18px;border-radius:50%;background:#0a0e14;transition:left .2s}.switch.on:after{left:21px}.divider{margin-top:12px;padding-top:12px;border-top:1px dashed var(--border)}.actions{display:flex;gap:10px}.primary{flex:1;border:0;border-radius:14px;padding:14px;background:var(--teal);color:#04231d;font-weight:700}.icon-btn,.logout{border:0;border-radius:10px;cursor:pointer}.icon-btn{width:52px;background:var(--panel2);border:1px solid var(--border);color:var(--dim)}.logout{background:#e5484de6;color:white;padding:8px 12px;display:flex;gap:6px;align-items:center}.notice{margin-top:12px;padding:10px 12px;border-radius:10px;color:#ffb4b7;background:#e5484d1f;border:1px solid #e5484d59;font:12px Inter}.notice.success{color:#a8f5e5;background:#2bd9b91f;border-color:#2bd9b959}.notice.info{color:#ffd9a8;background:#f2994a1f;border-color:#f2994a59;line-height:1.6}.dirty{color:var(--amber);font:11px Inter}.settings-head{display:flex;align-items:center;justify-content:space-between}.log{margin-top:20px;overflow:hidden}.log-row{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid var(--border)}.log-row:last-child{border:0}.log-name{font:12.5px Inter}.log-state,.log-time{color:var(--dim);font:10px 'JetBrains Mono'}.log-state.success{color:var(--teal)}.log-state.failed{color:var(--red)}.log-state.expired{color:var(--amber)}.modal-backdrop{position:fixed;z-index:20;inset:0;background:#03060ac7;display:grid;place-items:center;padding:18px}.modal{width:100%;max-width:400px;background:var(--panel);border:1px solid var(--border);border-radius:18px;padding:20px;box-shadow:0 24px 80px #0000008c}.impact{background:var(--panel2);border-radius:12px;padding:14px;display:grid;gap:11px}.impact-label{color:var(--dim);font:11px Inter}.impact-value{font:12px 'JetBrains Mono';margin-top:3px}.modal-actions{display:flex;gap:10px;margin-top:18px}.modal-actions button{flex:1;padding:11px;border-radius:11px;cursor:pointer}.cancel{background:var(--panel2);color:var(--text);border:1px solid var(--border)}.confirm{background:var(--red);color:white;border:0}.toast{position:fixed;z-index:30;bottom:24px;left:50%;transform:translateX(-50%);background:var(--panel);border:1px solid var(--border);padding:10px 18px;border-radius:12px;font:13px Inter;box-shadow:0 8px 24px #0006;max-width:calc(100vw - 32px)}.log-row.new-row{animation:rowHighlight 2.5s ease-out;border-radius:10px}@keyframes rowHighlight{from{background:#2bd9b933;box-shadow:0 0 0 1px #2bd9b959}to{background:transparent;box-shadow:0 0 0 1px transparent}}.center{min-height:calc(100vh - 32px);display:grid;place-items:center}.login{width:100%;max-width:390px}.login h1{font-size:23px;margin:16px 0 6px}.login .field{margin-top:14px}.login .primary{width:100%;margin-top:18px}.login-logo{width:44px;height:44px;border-radius:12px;background:var(--blue);display:grid;place-items:center}.select-wrap{position:relative}.select-wrap svg{position:absolute;right:12px;top:50%;transform:translateY(-50%);pointer-events:none}@media(max-width:380px){.grid{grid-template-columns:1fr}.header{padding:16px 14px}.logout span{display:none}}@media(prefers-reduced-motion:reduce){*{transition:none!important;animation:none!important}}
`;

async function api(path, { token, method = "GET", body } = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      ...(body ? { "content-type": "application/json" } : {}),
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const details = data.details?.map((item) => `${item.field}: ${item.message}`).join(", ");
    const error = new Error(details || data.error || `HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return data;
}

async function uploadBanner(file, token) {
  const response = await fetch(`${API_BASE}/admin/ads/upload`, {
    method: "POST",
    headers: { "content-type": file.type, authorization: `Bearer ${token}` },
    body: file,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || `HTTP ${response.status}`);
  return data.url;
}

/** Downscale + re-encode ke webp sebelum upload — foto HP sering >1MB padahal
 * popup cuma butuh ~800x600. GIF dilewati supaya animasinya tidak hilang. */
function compressImage(file, maxDim = 1600, quality = 0.82) {
  if (file.type === "image/gif") return Promise.resolve(file);
  return new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const scale = Math.min(1, maxDim / Math.max(img.naturalWidth, img.naturalHeight));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.naturalWidth * scale);
      canvas.height = Math.round(img.naturalHeight * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => resolve(blob || file), "image/webp", quality);
    };
    img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(file); };
    img.src = objectUrl;
  });
}

/** Baca lebar/tinggi asli gambar supaya admin tidak isi manual dan salah ketik. */
function readImageSize(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => reject(new Error("Gagal membaca ukuran gambar"));
    img.src = url;
  });
}

function fromApi(value) {
  const text = (key, fallback) => String(value?.[key] ?? fallback);
  return {
    comment: value?.comment ?? DEFAULT_SETTINGS.comment,
    baseLot: text("base_lot", DEFAULT_SETTINGS.baseLot),
    maxLayers: text("max_layers", DEFAULT_SETTINGS.maxLayers),
    stepPoints: text("step_points", DEFAULT_SETTINGS.stepPoints),
    lotIncrement: text("lot_increment", DEFAULT_SETTINGS.lotIncrement),
    tpPerSide: text("tp_per_side", DEFAULT_SETTINGS.tpPerSide),
    tpTotal: text("tp_total", DEFAULT_SETTINGS.tpTotal),
    useDynamicTP: value?.use_dynamic_tp ?? DEFAULT_SETTINGS.useDynamicTP,
    tpLevels: Object.fromEntries(Object.entries(value?.tp_levels || DEFAULT_SETTINGS.tpLevels)
      .map(([key, number]) => [key, String(number)])),
    useStopLoss: value?.use_stop_loss ?? DEFAULT_SETTINGS.useStopLoss,
    slPoints: text("sl_points", DEFAULT_SETTINGS.slPoints),
    useDailyTP: value?.use_daily_tp ?? DEFAULT_SETTINGS.useDailyTP,
    dailyTP: text("daily_tp", DEFAULT_SETTINGS.dailyTP),
    maxSpread: text("max_spread", DEFAULT_SETTINGS.maxSpread),
    slippage: text("slippage", DEFAULT_SETTINGS.slippage),
    minSecBetweenOps: text("min_sec_between_ops", DEFAULT_SETTINGS.minSecBetweenOps),
    allowBothSides: value?.allow_both_sides ?? DEFAULT_SETTINGS.allowBothSides,
    allowBuy: value?.allow_buy ?? DEFAULT_SETTINGS.allowBuy,
    allowSell: value?.allow_sell ?? DEFAULT_SETTINGS.allowSell,
    autoStart: value?.auto_start ?? DEFAULT_SETTINGS.autoStart,
    startMode: value?.start_mode ?? DEFAULT_SETTINGS.startMode,
  };
}

function number(raw, label, { integer = false, min, exclusive = false } = {}) {
  if (String(raw).trim() === "") throw new Error(`${label} wajib diisi`);
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) throw new Error(`${label} harus berupa angka`);
  if (integer && !Number.isInteger(parsed)) throw new Error(`${label} harus bilangan bulat`);
  if (min !== undefined && (exclusive ? parsed <= min : parsed < min)) {
    throw new Error(`${label} harus ${exclusive ? "lebih besar dari" : "minimal"} ${min}`);
  }
  return parsed;
}

function toApi(value) {
  return {
    comment: value.comment,
    base_lot: number(value.baseLot, "Lot Awal", { min: 0, exclusive: true }),
    max_layers: number(value.maxLayers, "Maks. Layer", { integer: true, min: 1 }),
    step_points: number(value.stepPoints, "Jarak Grid", { min: 0, exclusive: true }),
    lot_increment: number(value.lotIncrement, "Penambahan Lot", { min: 0 }),
    tp_per_side: number(value.tpPerSide, "TP per Sisi"),
    tp_total: number(value.tpTotal, "TP Total Basket"),
    use_dynamic_tp: value.useDynamicTP,
    tp_levels: Object.fromEntries(Object.entries(value.tpLevels)
      .map(([key, raw]) => [key, number(raw, `TP Layer ${key}`, { min: 0 })])),
    use_stop_loss: value.useStopLoss,
    sl_points: number(value.slPoints, "Stop Loss", { min: 0 }),
    use_daily_tp: value.useDailyTP,
    daily_tp: number(value.dailyTP, "Target Profit Sesi"),
    max_spread: number(value.maxSpread, "Maks. Spread", { min: 0 }),
    slippage: number(value.slippage, "Slippage", { integer: true, min: 0 }),
    min_sec_between_ops: number(value.minSecBetweenOps, "Jeda Minimum", { integer: true, min: 0 }),
    allow_both_sides: value.allowBothSides,
    allow_buy: value.allowBuy,
    allow_sell: value.allowSell,
    auto_start: value.autoStart,
    start_mode: value.startMode,
  };
}

const formatTime = (iso) => iso ? `${new Date(iso).toLocaleString("id-ID", {
  timeZone: "Asia/Jakarta", dateStyle: "short", timeStyle: "medium", hour12: false,
})} WIB` : "—";

const formatMoney = (value) => Number.isFinite(Number(value))
  ? new Intl.NumberFormat("id-ID", { style: "currency", currency: "USD" }).format(Number(value))
  : "Belum tersedia";

function impactOf(cmd, heartbeat) {
  if (!heartbeat) return { positions: "Belum tersedia (EA belum heartbeat)", profit: "Belum tersedia" };
  const buy = Number(heartbeat.buy_layers || 0);
  const sell = Number(heartbeat.sell_layers || 0);
  const buyProfit = Number(heartbeat.buy_profit || 0);
  const sellProfit = Number(heartbeat.sell_profit || 0);
  if (cmd === "CMD_STOP") return {
    positions: `${buy + sell} posisi DIBIARKAN terbuka, TP tetap dipantau. Tidak ada layer baru.`,
    profit: formatMoney(buyProfit + sellProfit),
  };
  if (cmd === "CMD_PANIC_STOP") return {
    positions: `${buy + sell} posisi akan ditutup DAN entry baru dimatikan`,
    profit: formatMoney(buyProfit + sellProfit),
  };
  if (cmd === "CMD_CLOSE_ALL") return { positions: `${buy + sell} posisi akan ditutup`, profit: formatMoney(buyProfit + sellProfit) };
  if (cmd === "CMD_CLOSE_BUY") return { positions: `${buy} posisi Buy akan ditutup`, profit: formatMoney(buyProfit) };
  if (cmd === "CMD_CLOSE_SELL") return { positions: `${sell} posisi Sell akan ditutup`, profit: formatMoney(sellProfit) };
  if (cmd === "CMD_START") return {
    positions: "Entry baru diizinkan lagi, sesuai Start Mode & Allow Buy/Sell di Settings",
    profit: formatMoney(buyProfit + sellProfit),
  };
  return {
    positions: `1 posisi ${cmd === "CMD_BUY_NOW" ? "Buy" : "Sell"} baru akan dibuka`,
    profit: formatMoney(buyProfit + sellProfit),
  };
}

export default function EARemoteController() {
  const [token, setToken] = useState(() => typeof window === "undefined"
    ? "" : window.localStorage.getItem(TOKEN_KEY) || "");
  const [authMode, setAuthMode] = useState(() => typeof window === "undefined"
    ? "login" : new URLSearchParams(window.location.search).get("mode") === "register" ? "register" : "login");
  const login = useCallback((next) => {
    window.localStorage.setItem(TOKEN_KEY, next);
    setToken(next);
  }, []);
  const logout = useCallback(() => {
    window.localStorage.removeItem(TOKEN_KEY);
    setToken("");
  }, []);
  return <App>{token ? <Controller token={token} onLogout={logout} />
    : authMode === "register"
      ? <Register onSwitch={() => setAuthMode("login")} />
      : <Login onLogin={login} onSwitch={() => setAuthMode("register")} />}</App>;
}

function App({ children }) {
  return <div className="app"><style>{CSS}</style><div className="wrap">{children}</div></div>;
}

const SWITCH_LINK_STYLE = { display: "block", marginTop: 16, width: "100%", background: "none", border: 0, color: "var(--teal)", cursor: "pointer", font: "13px Inter, sans-serif", textAlign: "center", textDecoration: "none" };

function Login({ onLogin, onSwitch }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      const data = await api("/auth/login", { method: "POST", body: { email, password } });
      onLogin(data.token);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div className="center"><form className="card login" onSubmit={submit}>
    <h1 className="auth-brand"><Brand wordmark /></h1>
    <div className="muted">Masuk untuk mengelola akun MT5 Anda.</div>
    <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="username" />
    <Field label="Password" type="password" value={password} onChange={setPassword} autoComplete="current-password" />
    {error && <div className="notice" role="alert">{error}</div>}
    <button className="primary" disabled={busy}>{busy ? "MASUK…" : "MASUK"}</button>
    <button type="button" style={SWITCH_LINK_STYLE} onClick={onSwitch}>Belum punya akun? Daftar</button>
    <a href="https://smartremoteassistant.com" style={SWITCH_LINK_STYLE}>smartremoteassistant.com</a>
  </form></div>;
}

function Register({ onSwitch }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sentTo, setSentTo] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirm) { setError("Konfirmasi password tidak cocok"); return; }
    setBusy(true); setError("");
    try {
      await api("/auth/register", { method: "POST", body: { email, password } });
      setSentTo(email);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  if (sentTo) {
    return <div className="center"><div className="card login">
      <div className="login-logo"><Mail size={22} /></div>
      <h1>Cek Email Anda</h1>
      <div className="muted">
        Link verifikasi sudah dikirim ke <strong>{sentTo}</strong>. Buka email
        tersebut dan klik link-nya untuk mengaktifkan akun sebelum masuk.
      </div>
      <button type="button" className="primary" style={{ marginTop: 18 }} onClick={onSwitch}>
        Sudah verifikasi? Masuk
      </button>
    </div></div>;
  }

  return <div className="center"><form className="card login" onSubmit={submit}>
    <div className="auth-brand"><Brand wordmark /></div>
    <h1>Buat Akun</h1><div className="muted">Daftar untuk mulai mengelola EA MT5 Anda dari dashboard.</div>
    <Field label="Email" type="email" value={email} onChange={setEmail} autoComplete="username" />
    <Field label="Password" type="password" value={password} onChange={setPassword} autoComplete="new-password" />
    <Field label="Konfirmasi Password" type="password" value={confirm} onChange={setConfirm} autoComplete="new-password" />
    {error && <div className="notice" role="alert">{error}</div>}
    <button className="primary" disabled={busy}>{busy ? "MENDAFTAR…" : "DAFTAR"}</button>
    <button type="button" style={SWITCH_LINK_STYLE} onClick={onSwitch}>Sudah punya akun? Masuk</button>
  </form></div>;
}

function Controller({ token, onLogout }) {
  const [layout, setLayout] = useState(() => {
    try { return window.localStorage.getItem("ea-remote-layout") === "classic" ? "classic" : "workspace"; }
    catch { return "workspace"; }
  });
  const workspace = layout === "workspace";
  const switchLayout = () => {
    const next = workspace ? "classic" : "workspace";
    setLayout(next);
    try { window.localStorage.setItem("ea-remote-layout", next); } catch { /* Preference still works for this session. */ }
  };
  const [ready, setReady] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountId] = useState("");
  const [status, setStatus] = useState(null);
  const [commands, setCommands] = useState([]);
  const [user, setUser] = useState(null);
  const [saved, setSaved] = useState(null);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [tab, setTab] = useState("command");
  const [busy, setBusy] = useState(null);
  const [saving, setSaving] = useState(false);
  const [confirming, setConfirming] = useState(null);
  const [toast, setToast] = useState("");
  const [error, setError] = useState("");
  const [revealApiKey, setRevealApiKey] = useState(null);
  const [addingAccount, setAddingAccount] = useState(false);
  const [deletingAccount, setDeletingAccount] = useState(false);
  const [deleteBusy, setDeleteBusy] = useState(false);
  const [rotatingKey, setRotatingKey] = useState(false);
  const [rotateBusy, setRotateBusy] = useState(false);

  const fail = useCallback((err) => err.status === 401 ? onLogout() : setError(err.message), [onLogout]);

  useEffect(() => {
    let active = true; setReady(false);
    Promise.all([api("/accounts", { token }), api("/auth/me", { token })]).then(([data, profile]) => {
      if (!active) return;
      setAccounts(data.accounts);
      setUser(profile.user);
      setAccountId((current) => data.accounts.some((item) => item.id === current)
        ? current : data.accounts[0]?.id || "");
      if (!data.accounts.length) setReady(true);
    }).catch((err) => { if (active) { fail(err); setReady(true); } });
    return () => { active = false; };
  }, [token, fail]);

  useEffect(() => {
    if (!accountId) return undefined;
    let active = true; setReady(false); setError(""); setStatus(null); setCommands([]); setSaved(null); setSettings(DEFAULT_SETTINGS);
    Promise.all([
      api(`/accounts/${accountId}/settings`, { token }),
      api(`/accounts/${accountId}/status`, { token }),
      api(`/accounts/${accountId}/commands?limit=25`, { token }),
    ]).then(([settingsData, statusData, commandData]) => {
      if (!active) return;
      const next = fromApi(settingsData.settings);
      setSaved(next); setSettings(next); setStatus(statusData); setCommands(commandData.commands);
    }).catch((err) => { if (active) fail(err); })
      .finally(() => { if (active) setReady(true); });
    return () => { active = false; };
  }, [accountId, token, fail]);

  useEffect(() => {
    if (!accountId) return undefined;
    let active = true;
    const refresh = async () => {
      try {
        const [nextStatus, nextCommands] = await Promise.all([
          api(`/accounts/${accountId}/status`, { token }),
          api(`/accounts/${accountId}/commands?limit=25`, { token }),
        ]);
        if (active) { setStatus(nextStatus); setCommands(nextCommands.commands); }
      } catch (err) { if (active) fail(err); }
    };
    const timer = window.setInterval(refresh, 3000);
    return () => { active = false; window.clearInterval(timer); };
  }, [accountId, token, fail]);

  const onAccountCreated = (newAccount, apiKey) => {
    setAccounts((current) => [...current, newAccount]);
    setAccountId(newAccount.id);
    setAddingAccount(false);
    setRevealApiKey({ apiKey, mt5_account: newAccount.mt5_account });
  };

  if (!ready) return <div className="center muted">Memuat dashboard…</div>;
  // Admin tidak punya akun MT5 sendiri — jangan biarkan jatuh ke NoAccountGuide.
  if (user?.role === "admin") return <AdminDashboard token={token} user={user} onLogout={onLogout} />;
  const account = accounts.find((item) => item.id === accountId);
  if (!account) return <>
    <NoAccountGuide token={token} onLogout={onLogout} onCreated={onAccountCreated} />
    {revealApiKey && <ApiKeyReveal apiKey={revealApiKey.apiKey} mt5Account={revealApiKey.mt5_account} onDone={() => setRevealApiKey(null)} />}
  </>;

  const dirty = Boolean(saved) && JSON.stringify(settings) !== JSON.stringify(saved);
  const update = (patch) => setSettings((current) => ({ ...current, ...patch }));
  const updateLevel = (key, value) => setSettings((current) => ({
    ...current, tpLevels: { ...current.tpLevels, [key]: value },
  }));
  const notify = (message) => {
    setToast(message); window.setTimeout(() => setToast(""), 2600);
  };
  const save = async () => {
    setSaving(true); setError("");
    try {
      const data = await api(`/accounts/${accountId}/settings`, {
        token, method: "PUT", body: toApi(settings),
      });
      const next = fromApi(data.settings);
      setSaved(next); setSettings(next); notify("Pengaturan berhasil disimpan");
    } catch (err) { fail(err); notify(`Gagal menyimpan: ${err.message}`); }
    finally { setSaving(false); }
  };
  const send = async () => {
    if (!confirming || busy) return;
    const cmd = confirming.cmd; setConfirming(null); setBusy(cmd); setError("");
    try {
      const data = await api(`/accounts/${accountId}/commands`, {
        token, method: "POST", body: { cmd },
      });
      setCommands((current) => [data.command, ...current].slice(0, 25));
      notify("Perintah masuk antrean EA");
    } catch (err) { fail(err); notify(`Perintah gagal dikirim: ${err.message}`); }
    finally { setBusy(null); }
  };
  const openConfirm = (cmd) => { if (!busy) setConfirming({ cmd, label: COMMANDS[cmd] }); };
  const rotateKey = async () => {
    setRotateBusy(true);
    try {
      const data = await api(`/accounts/${account.id}/rotate-key`, { token, method: "POST" });
      setRotatingKey(false);
      setRevealApiKey({ apiKey: data.api_key, mt5_account: account.mt5_account });
      notify("API key baru dibuat — key lama berhenti berlaku");
    } catch (err) { fail(err); notify(`Gagal membuat API key baru: ${err.message}`); }
    finally { setRotateBusy(false); }
  };
  const deleteAccount = async () => {
    setDeleteBusy(true);
    try {
      await api(`/accounts/${account.id}`, { token, method: "DELETE" });
      const remaining = accounts.filter((item) => item.id !== account.id);
      setAccounts(remaining);
      setAccountId(remaining[0]?.id || "");
      setDeletingAccount(false);
      notify("Akun berhasil dihapus");
    } catch (err) { fail(err); notify(`Gagal menghapus akun: ${err.message}`); }
    finally { setDeleteBusy(false); }
  };

  const accountLocked = Boolean(busy || confirming || saving);
  const selectAccount = (id) => {
    if (!accountLocked && id !== accountId) { setReady(false); setAccountId(id); }
  };
  return <>
    <div className={workspace ? "workspace" : "classic"}>
    {workspace && <aside className="workspace-rail" aria-label="Navigasi workspace">
      <div className="logo"><Brand /></div>
      <nav>
        <button title="Control" aria-label="Control" aria-pressed={tab === "command"} onClick={() => setTab("command")}><LayoutDashboard size={22} /></button>
        <button title="Monitoring" aria-label="Monitoring" aria-pressed={tab === "monitoring"} onClick={() => setTab("monitoring")}><Activity size={22} /></button>
        <button title="Settings" aria-label="Settings" aria-pressed={tab === "dashboard"} onClick={() => setTab("dashboard")}><Settings2 size={22} /></button>
        <button title="Profile" aria-label="Profile" aria-pressed={tab === "profile"} onClick={() => setTab("profile")}><UserRound size={22} /></button>
      </nav>
      <button className="rail-logout" title="Logout" aria-label="Logout" onClick={onLogout}><LogOut size={20} /></button>
    </aside>}
    <main className={workspace ? "workspace-main" : undefined}>
    {workspace ? <header className="workspace-header">
      <div><div className="workspace-eyebrow">SMART REMOTE EA ASSISTANT</div><h1>Workspace</h1><p className="muted">Pantau dan kendalikan EA MetaTrader 5</p></div>
      <button className="layout-switch" onClick={switchLayout}><Monitor size={16} /> Switch to classic UI</button>
      <nav className="tabs" aria-label="Halaman workspace">
        <Tab active={tab === "command"} onClick={() => setTab("command")}>Control</Tab>
        <Tab active={tab === "monitoring"} onClick={() => setTab("monitoring")}>Monitoring</Tab>
        <Tab active={tab === "dashboard"} onClick={() => setTab("dashboard")}>Settings{dirty ? " •" : ""}</Tab>
        <Tab active={tab === "profile"} onClick={() => setTab("profile")}>Profile</Tab>
      </nav>
    </header> : <>
      <Header accounts={accounts} account={account} accountId={accountId} setAccountId={selectAccount} onLogout={onLogout} accountLocked={accountLocked} />
      <div className="classic-actions"><button className="layout-switch" onClick={() => setTab("profile")}><UserRound size={16} /> Profile</button>
      <button className="layout-switch" onClick={switchLayout}><LayoutDashboard size={16} /> Try workspace UI</button></div>
    </>}
    <div className={workspace ? "workspace-content" : undefined}>
    {error && <div className="notice" role="alert">{error}</div>}
    <div className="notice info">
      <b>Perhatian!</b> Berikut adalah menu dashboard untuk seting EA dan menjalankan EA.
      <br />Setingan yang ada di dashboard adalah setingan default, yaitu setingan low risk untuk XAU saat ini,
      dan perlu disetel ulang jika market bergerak dinamis. Anda boleh melakukan riset dan mengganti parameter EA sesuai kebutuhan.
      <br />Trading di pasar CFD dan derivatif mengandung risiko kehilangan uang selain mendapatkan keuntungan —
      pelajari risikonya terlebih dahulu sebelum bertransaksi di instrumen ini.
    </div>
    {!workspace && <nav className="tabs">
      <Tab icon={<Home size={16} />} active={tab === "dashboard"} onClick={() => setTab("dashboard")}>Dashboard</Tab>
      <Tab icon={<Gamepad2 size={16} />} active={tab !== "dashboard"} onClick={() => setTab("command")}>Command</Tab>
    </nav>}
    {workspace && <WorkspaceSummary account={account} status={status} />}
    {tab === "profile" ? <ProfilePage user={user} accounts={accounts} token={token} onLogout={onLogout} notify={notify} />
    : tab !== "dashboard"
      ? <CommandPage account={account} status={status} commands={commands} busy={busy} openConfirm={openConfirm}
          view={workspace ? tab : "classic"} />
      : <SettingsPage account={account} settings={settings} update={update} updateLevel={updateLevel}
          dirty={dirty} saving={saving} save={save} notify={notify}
          onAddAccount={() => setAddingAccount(true)} onDeleteAccount={() => setDeletingAccount(true)}
          onRotateKey={() => setRotatingKey(true)} />}
    </div>
    </main>
    {workspace && <aside className="workspace-accounts" aria-label="Akun MT5">
      <header><h2>Akun terhubung <span>{accounts.length}</span></h2><p className="muted">Pilih terminal MT5 yang dikelola</p></header>
      <div className="workspace-account-list">{accounts.map((item) => <button key={item.id}
        className={item.id === accountId ? "terminal selected" : "terminal"} aria-pressed={item.id === accountId}
        disabled={accountLocked} onClick={() => selectAccount(item.id)}>
        <div className="terminal-title"><Building2 size={18} /><strong>{item.mt5_account}</strong></div>
        <div className="muted">{item.broker || "Broker belum diisi"}</div>
        <div className="terminal-server">{item.server || "Server belum diisi"}</div>
        {item.id === accountId ? <div className={`status ${status?.online ? "online" : "offline"}`}><span className="dot" />{status?.online ? "ONLINE" : "OFFLINE"}</div>
          : <div className="terminal-unknown">Pilih untuk melihat status</div>}
      </button>)}</div>
      <footer><button className="layout-switch" onClick={() => setAddingAccount(true)} disabled={accountLocked}><Plus size={16} /> Tambah akun</button>
      <p className="muted">Setiap perintah dikirim ke akun yang dipilih.</p></footer>
    </aside>}
    </div>
    {confirming && <Confirm command={confirming} account={account}
      impact={impactOf(confirming.cmd, status?.heartbeat)} onCancel={() => setConfirming(null)} onConfirm={send} />}
    {addingAccount && <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && setAddingAccount(false)}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="add-account-title">
        <h3 id="add-account-title">Tambah Akun MT5</h3>
        <AddAccountForm token={token} onCreated={onAccountCreated} onCancel={() => setAddingAccount(false)} />
      </div>
    </div>}
    {deletingAccount && <DeleteAccountConfirm account={account} busy={deleteBusy}
      onCancel={() => setDeletingAccount(false)} onConfirm={deleteAccount} />}
    {rotatingKey && <RotateKeyConfirm account={account} busy={rotateBusy}
      onCancel={() => setRotatingKey(false)} onConfirm={rotateKey} />}
    {revealApiKey && <ApiKeyReveal apiKey={revealApiKey.apiKey} mt5Account={revealApiKey.mt5_account} onDone={() => setRevealApiKey(null)} />}
    {toast && <div className="toast" role="status">{toast}</div>}
  </>;
}

function NoAccountGuide({ token, onLogout, onCreated }) {
  const [mode, setMode] = useState("self_hosted");
  return <div className="center"><div className="card" style={{ maxWidth: 420 }}>
    <h2 style={{ marginTop: 0 }}>Akun Anda aktif</h2>
    <div className="muted" style={{ marginBottom: 10 }}>Belum ada akun MT5 terhubung. Pilih cara pasang (PRD §5):</div>
    <nav className="tabs" style={{ marginTop: 0 }}>
      <Tab active={mode === "self_hosted"} onClick={() => setMode("self_hosted")}>Self-hosted</Tab>
      <Tab active={mode === "managed"} onClick={() => setMode("managed")}>Managed</Tab>
    </nav>
    {mode === "self_hosted"
      ? <>
          <div className="muted" style={{ margin: "14px 0 10px", fontSize: 13, lineHeight: 1.6 }}>
            Daftarkan akun MT5-nya dulu — sistem akan membuatkan API key untuk
            akun itu, lalu tinggal di-attach ke EA.
          </div>
          <AddAccountForm token={token} onCreated={onCreated} />
          <ol style={{ margin: "16px 0 0", paddingLeft: 18, fontSize: 12.5, lineHeight: 1.6, color: "var(--dim)" }}>
            <li>Di MT5: Tools → Options → Expert Advisors → centang Allow WebRequest, masukkan domain server</li>
            <li>Attach EA ke chart, isi input InpApiKey (dari langkah di atas) dan InpServerUrl</li>
            <li>EA mengirim heartbeat pertama → akun ini otomatis muncul di sini dengan status ONLINE</li>
          </ol>
        </>
      : <div style={{ marginTop: 14 }}>
          <div className="notice">Jalur managed (tim kami yang setup) belum punya form otomatis.</div>
          <div className="muted" style={{ marginTop: 10, fontSize: 13, lineHeight: 1.6 }}>
            Hubungi admin Anda untuk dibantu setup manual. Kredensial broker akan
            diminta langsung olehnya lewat jalur terpisah — <b>tidak</b> disimpan
            di sistem ini.
          </div>
        </div>}
    <button className="primary" style={{ marginTop: 16 }} onClick={onLogout}>Logout</button>
  </div></div>;
}

/** deployment_mode selalu self_hosted — jalur managed belum ada operator
 * self-service, lihat NoAccountGuide di atas. */
function AddAccountForm({ token, onCreated, onCancel }) {
  const [mt5Account, setMt5Account] = useState("");
  const [broker, setBroker] = useState("");
  const [server, setServer] = useState("");
  const [magic, setMagic] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      const data = await api("/accounts", {
        token, method: "POST", body: { mt5_account: mt5Account, broker, server, magic: Number(magic) },
      });
      onCreated(data.account, data.api_key);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <form onSubmit={submit}>
    <div className="grid">
      <Field label="Nomor Akun MT5" type="text" value={mt5Account} onChange={setMt5Account} />
      <Field label="Magic Number" value={magic} onChange={setMagic} />
      <Field label="Broker" type="text" value={broker} onChange={setBroker} />
      <Field label="Server" type="text" value={server} onChange={setServer} />
    </div>
    {error && <div className="notice" role="alert">{error}</div>}
    <div className="actions" style={{ marginTop: 12 }}>
      <button className="primary" disabled={busy}>{busy ? "MENAMBAHKAN…" : "TAMBAH AKUN"}</button>
      {onCancel && <button type="button" className="icon-btn" style={{ width: "auto", padding: "0 16px" }} onClick={onCancel}>Batal</button>}
    </div>
  </form>;
}

/** API key hanya tampil sekali (PRD §8.2) — tidak ada jalan untuk melihatnya lagi selain rotate. */
function ApiKeyReveal({ apiKey, mt5Account, onDone }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(apiKey); setCopied(true); }
    catch { /* clipboard API tidak tersedia; key tetap terlihat untuk disalin manual */ }
  };
  return <div className="modal-backdrop">
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="apikey-title">
      <h3 id="apikey-title">API Key — {mt5Account}</h3>
      <p className="muted">Simpan sekarang, key ini <b>tidak akan ditampilkan lagi</b>. Pakai untuk InpApiKey di EA.</p>
      <div className="impact"><div className="impact-value" style={{ wordBreak: "break-all" }}>{apiKey}</div></div>
      <div className="modal-actions">
        <button className="cancel" onClick={copy}>{copied ? "Tersalin ✓" : "Salin"}</button>
        <button className="confirm" style={{ background: "var(--blue)" }} onClick={onDone}>Selesai</button>
      </div>
    </div>
  </div>;
}

function DeleteAccountConfirm({ account, busy, onCancel, onConfirm }) {
  return <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onCancel()}>
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="delete-title">
      <h3 id="delete-title">Hapus Akun {account.mt5_account}?</h3>
      <p className="muted">
        Pengaturan, riwayat perintah, dan histori heartbeat akun ini terhapus
        permanen. EA yang masih attach dengan API key lama akan berhenti
        terhubung. Tindakan ini tidak bisa dibatalkan.
      </p>
      <div className="modal-actions">
        <button className="cancel" onClick={onCancel}>Batal</button>
        <button className="confirm" disabled={busy} onClick={onConfirm}>{busy ? "MENGHAPUS…" : "Ya, hapus"}</button>
      </div>
    </div>
  </div>;
}

function RotateKeyConfirm({ account, busy, onCancel, onConfirm }) {
  return <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onCancel()}>
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="rotate-title">
      <h3 id="rotate-title">Buat API Key Baru untuk {account.mt5_account}?</h3>
      <p className="muted">
        Key lama langsung berhenti berlaku. EA yang masih memakai InpApiKey
        lama akan gagal terhubung (401) sampai diisi ulang dengan key baru —
        pastikan hanya satu terminal MT5 yang memakai key akun ini.
      </p>
      <div className="modal-actions">
        <button className="cancel" onClick={onCancel}>Batal</button>
        <button className="confirm" disabled={busy} onClick={onConfirm}>{busy ? "MEMBUAT…" : "Ya, buat key baru"}</button>
      </div>
    </div>
  </div>;
}

function Header({ accounts, account, accountId, setAccountId, onLogout, accountLocked }) {
  return <header className="header"><div className="brand"><div className="logo"><Brand /></div><div>
    <div className="title">Smart Remote EA Assistant</div>
    {accounts.length > 1
      ? <select className="account-pill" aria-label="Akun MT5" disabled={accountLocked} value={accountId} onChange={(event) => setAccountId(event.target.value)}>
          {accounts.map((item) => <option key={item.id} value={item.id}>{item.mt5_account} · {item.broker}</option>)}
        </select>
      : <div className="account-pill">Account : {account.mt5_account}</div>}
  </div></div><button className="logout" onClick={onLogout}><LogOut size={13} /><span>Logout</span></button></header>;
}

/** Kondisi akun apa adanya dari heartbeat terakhir: uangnya, lalu posisinya. */
function WorkspaceSummary({ account, status }) {
  const hb = status?.heartbeat;
  const floating = hb ? Number(hb.buy_profit || 0) + Number(hb.sell_profit || 0) : null;
  return <section className="workspace-summary" aria-label="Ringkasan akun">
    <div className="summary-heading">
      <div><div className="workspace-eyebrow">AKUN MT5 AKTIF</div><h2>{account.mt5_account} <span>· {account.broker || "Broker belum diisi"}</span></h2>
        <div className="muted">{account.server || "Server belum diisi"}</div></div>
      <div className={`status ${status?.online ? "online" : "offline"}`}><span className="dot" />{status?.online ? "ONLINE" : "OFFLINE"}</div>
    </div>
    <div className="summary-metrics">
      <StatCard label="Floating P/L" value={floating === null ? "Belum tersedia" : formatMoney(floating)} color={floating < 0 ? "var(--red)" : "var(--teal)"} />
      <StatCard label="Saldo" value={hb?.balance == null ? "Belum tersedia" : formatMoney(hb.balance)} />
      <StatCard label="Ekuitas" value={hb?.equity == null ? "Belum tersedia" : formatMoney(hb.equity)} />
      <StatCard label="Free Margin" value={hb?.free_margin == null ? "Belum tersedia" : formatMoney(hb.free_margin)} />
    </div>
    <div className="fine">{status?.last_heartbeat_seconds_ago == null ? "Belum pernah menerima heartbeat dari EA."
      : `Heartbeat ${status.last_heartbeat_seconds_ago} detik lalu · ${hb?.margin_mode || "mode tidak diketahui"}`}
      {!status?.online && hb && " · Menampilkan snapshot terakhir, bukan kondisi terkini."}</div>
  </section>;
}

function AccountPanel({ heartbeat, compact = false }) {
  if (!heartbeat && !compact) return null;

  const positions = Array.isArray(heartbeat?.positions) ? heartbeat.positions : null;
  const total = Number(heartbeat?.positions_total ?? (positions ? positions.length : 0));

  if (compact) return <Panel icon={<Activity size={16} />} title={`Posisi berjalan · ${total}`}>
    {positions === null
      ? <div className="muted" style={{ fontSize: 12 }}>Belum ada snapshot posisi dari heartbeat EA.</div>
      : positions.length === 0
        ? <div className="muted" style={{ fontSize: 12 }}>Tidak ada posisi terbuka.</div>
        : positions.map((p) => <div className="log-row" key={p.ticket}>
            <div><div className="log-name">
              <span style={{ color: p.type === "buy" ? "var(--teal)" : "var(--amber)", fontWeight: 700 }}>
                {p.type === "buy" ? "BUY" : "SELL"}</span> {Number(p.volume)} lot</div>
              <div className="log-state">{p.price_open} → {p.price_current} · #{p.ticket}</div></div>
            <div style={{ textAlign: "right", flex: "none" }}>
              <div style={{ font: "12px 'JetBrains Mono'", color: Number(p.profit) < 0 ? "var(--red)" : "var(--teal)" }}>
                {formatMoney(p.profit)}</div>
              <div className="log-time">{p.time}</div></div>
          </div>)}
    {positions && total > positions.length && <div className="fine">Menampilkan {positions.length} dari {total} posisi.</div>}
    {positions && positions.length > 0 && <div className="fine">Waktu &amp; harga dari terminal, apa adanya. Waktu memakai jam server broker, bukan WIB.</div>}
  </Panel>;

  const level = Number(heartbeat.margin_level);
  // Angka margin level baru berarti kalau dibaca sebagai jarak ke stop out.
  // Ambangnya beda-beda per broker, jadi warnanya sengaja kasar: cukup untuk
  // membuat orang melihat, tidak cukup untuk dianggap janji.
  const levelColor = !Number.isFinite(level) || level === 0 ? "var(--text)"
    : level < 100 ? "var(--red)" : level < 200 ? "var(--amber)" : "var(--teal)";
  const floating = Number(heartbeat.buy_profit || 0) + Number(heartbeat.sell_profit || 0);

  const buyLayers = Number(heartbeat.buy_layers || 0);
  const sellLayers = Number(heartbeat.sell_layers || 0);
  const basketDirection = buyLayers > 0 && sellLayers > 0 ? "BOTH" : buyLayers > 0 ? "BUY" : sellLayers > 0 ? "SELL" : "—";
  const basketColor = basketDirection === "BUY" ? "var(--teal)" : basketDirection === "SELL" ? "var(--amber)"
    : basketDirection === "BOTH" ? "var(--blue)" : "var(--dim)";

  return <Panel icon={<Wallet size={16} />} title="Kondisi Akun">
    <div className="grid">
      <StatCard label="Saldo" value={formatMoney(heartbeat.balance)} />
      <StatCard label="Ekuitas" value={formatMoney(heartbeat.equity)} />
      <StatCard label="Margin" value={formatMoney(heartbeat.margin)} />
      <StatCard label="Free Margin" value={formatMoney(heartbeat.free_margin)} />
      <StatCard label="Margin Level" color={levelColor}
        value={Number.isFinite(level) ? `${level.toLocaleString("id-ID", { maximumFractionDigits: 2 })} %` : "Belum tersedia"} />
      <StatCard label="Floating P/L" color={floating < 0 ? "var(--red)" : "var(--teal)"} value={formatMoney(floating)} />
      <StatCard label="Posisi Terbuka" value={total} />
      <StatCard label="Arah Basket" color={basketColor} value={basketDirection} />
    </div>

    <div className="divider">
      <div className="meta" style={{ marginTop: 0 }}>POSISI BERJALAN · {total}</div>
      {positions === null
        // Kolomnya null, bukan []: EA versi lama belum mengirim daftar posisi.
        // "Belum melapor" tidak boleh terbaca sebagai "tidak ada posisi".
        ? <div className="muted" style={{ fontSize: 12 }}>EA belum melaporkan daftar posisi — perbarui EA ke v1.13.</div>
        : positions.length === 0
          ? <div className="muted" style={{ fontSize: 12 }}>Tidak ada posisi terbuka.</div>
          : positions.map((p) => <div className="log-row" key={p.ticket}>
              <div><div className="log-name">
                <span style={{ color: p.type === "buy" ? "var(--teal)" : "var(--amber)", fontWeight: 700 }}>
                  {p.type === "buy" ? "BUY" : "SELL"}</span> {Number(p.volume)} lot</div>
                <div className="log-state">{p.price_open} → {p.price_current} · #{p.ticket}</div></div>
              <div style={{ textAlign: "right", flex: "none" }}>
                <div style={{ font: "12px 'JetBrains Mono'", color: Number(p.profit) < 0 ? "var(--red)" : "var(--teal)" }}>
                  {formatMoney(p.profit)}</div>
                <div className="log-time">{p.time}</div></div>
            </div>)}
      {positions && total > positions.length &&
        <div className="fine">Menampilkan {positions.length} dari {total} posisi.</div>}
      {positions && positions.length > 0 &&
        <div className="fine">Waktu & harga dari terminal, apa adanya. Waktu memakai jam server broker, bukan WIB.</div>}
    </div>
  </Panel>;
}

function StatCard({ label, value, color }) {
  return <div className="stat-card"><div className="stat-label">{label}</div>
    <div className="stat-value" style={color ? { color } : undefined}>{value}</div></div>;
}

function Tab({ icon, active, onClick, children }) {
  return <button className={`tab${active ? " active" : ""}`} aria-pressed={active} onClick={onClick}>{icon}{children}</button>;
}

function CommandPage({ account, status, commands, busy, openConfirm, view = "classic" }) {
  const online = Boolean(status?.online);
  return <section className="section">
    {view === "classic" && <><h2>Command Center</h2><div className="muted">Kirim perintah ke EA secara remote</div>
    <div className="card" style={{ marginTop: 12 }}>
      {commands[0]
        ? <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ background: "var(--panel2)", color: "var(--blue)", font: "600 11px 'JetBrains Mono'", padding: "3px 8px", borderRadius: 6 }}>
              {commands[0].cmd}
            </span>
            <span className={`log-state ${commands[0].status.toLowerCase()}`}>{commands[0].status}</span>
            <span className="log-time">{formatTime(commands[0].created_at)}</span>
          </div>
        : <div className="muted">Belum ada perintah dikirim</div>}
      <div className={`status ${online ? "online" : "offline"}`}><span className="dot" />{online ? "ONLINE" : "OFFLINE"}</div>
      <div className="meta"><Building2 size={13} />{account.broker || "Broker belum diisi"} • {account.server || "Server belum diisi"}</div>
      <div className="fine">{status?.last_heartbeat_seconds_ago == null
        ? "Belum pernah menerima heartbeat dari EA."
        : `Heartbeat ${status.last_heartbeat_seconds_ago} detik lalu · ${status.heartbeat?.margin_mode || "mode tidak diketahui"}`}</div>
    </div></>}
    {view !== "command" && <><AccountPanel heartbeat={status?.heartbeat} />
      {!status?.heartbeat && <div className="notice">Data monitoring belum tersedia. Menunggu heartbeat EA.</div>}</>}

    {view !== "monitoring" && <div className="ea-controls">
    {view === "command" && <AccountPanel heartbeat={status?.heartbeat} compact />}
    <div className="meta"><Gamepad2 size={13} /> KENDALI EA</div>
    <div className="master-controls">
    <CommandButton wide solid color="white" background="var(--teal)" border="var(--teal)"
      icon={<Play size={18} />} title="START" sub="Izinkan entry baru lagi, sesuai Start Mode & Allow Buy/Sell di Settings"
      disabled={Boolean(busy)} loading={busy === "CMD_START"} onClick={() => openConfirm("CMD_START")} />
    <CommandButton wide color="var(--amber)" background="#f2994a1a" border="#f2994a66"
      icon={<Pause size={18} />} title="STOP" sub="Setop entry baru. Posisi terbuka dibiarkan, TP tetap dipantau"
      disabled={Boolean(busy)} loading={busy === "CMD_STOP"} onClick={() => openConfirm("CMD_STOP")} />
    <CommandButton wide solid color="white" background="var(--red)" border="var(--red)"
      icon={<ShieldAlert size={18} />} title="PANIC STOP" sub="Setop entry baru DAN tutup semua posisi sekarang"
      disabled={Boolean(busy)} loading={busy === "CMD_PANIC_STOP"} onClick={() => openConfirm("CMD_PANIC_STOP")} />
    </div>
    <div className="fine">STOP &amp; PANIC STOP mematikan Izinkan Grid Buy &amp; Sell. START menyalakannya lagi lewat perintah yang sama cepatnya — tidak perlu menunggu tarikan Settings.</div>

    <div className="meta"><Radio size={13} /> TRADING COMMAND</div>
    <CommandButton wide color="var(--red)" background="#e5484d24" border="#e5484d66"
      icon={<X size={18} />} title="CLOSE ALL / RESET" sub="Tutup semua posisi Buy & Sell"
      disabled={Boolean(busy)} loading={busy === "CMD_CLOSE_ALL"} onClick={() => openConfirm("CMD_CLOSE_ALL")} />
    <div className="command-grid">
      <CommandButton color="var(--teal)" background="#2bd9b91a" border="#2bd9b959" icon={<ArrowUp size={16} />}
        title="CLOSE BUY" sub="Tutup posisi Buy" disabled={Boolean(busy)} loading={busy === "CMD_CLOSE_BUY"} onClick={() => openConfirm("CMD_CLOSE_BUY")} />
      <CommandButton color="var(--amber)" background="#f2994a1a" border="#f2994a59" icon={<ArrowDown size={16} />}
        title="CLOSE SELL" sub="Tutup posisi Sell" disabled={Boolean(busy)} loading={busy === "CMD_CLOSE_SELL"} onClick={() => openConfirm("CMD_CLOSE_SELL")} />
      <CommandButton solid color="white" background="var(--teal)" border="var(--teal)" icon={<ArrowUp size={16} />}
        title="BUY NOW" sub="Buka posisi Buy" disabled={Boolean(busy)} loading={busy === "CMD_BUY_NOW"} onClick={() => openConfirm("CMD_BUY_NOW")} />
      <CommandButton solid color="white" background="var(--amber)" border="var(--amber)" icon={<ArrowDown size={16} />}
        title="SELL NOW" sub="Buka posisi Sell" disabled={Boolean(busy)} loading={busy === "CMD_SELL_NOW"} onClick={() => openConfirm("CMD_SELL_NOW")} />
    </div>
    </div>}
    {view !== "command" && (commands.length > 0 ? <div className="panel log"><b>RIWAYAT PERINTAH</b>{commands.slice(0, 8).map((entry) =>
      <div className="log-row" key={entry.id}><div><div className="log-name">{COMMANDS[entry.cmd] || entry.cmd}</div>
        <div className={`log-state ${entry.status.toLowerCase()}`}>{entry.status}{entry.error_message ? ` · ${entry.error_message}` : ""}</div></div>
        <div className="log-time">{formatTime(entry.created_at)}</div></div>)}</div>
      : view === "monitoring" && <div className="panel log"><b>RIWAYAT PERINTAH</b><p className="muted">Belum ada perintah dikirim.</p></div>)}
    {view === "command" && commands[0] && <div className="workspace-last-command">
      <Radio size={16} /><div><span className="muted">Perintah terakhir</span><div className="log-name">{COMMANDS[commands[0].cmd] || commands[0].cmd}</div></div>
      <span className={`log-state ${commands[0].status.toLowerCase()}`}>{commands[0].status}</span>
    </div>}
  </section>;
}

function CommandButton({ icon, title, sub, onClick, disabled, loading, color, background, border, solid, wide }) {
  return <button className={`cmd${solid ? " solid" : ""}${wide ? " wide" : ""}`} disabled={disabled} onClick={onClick}
    style={{ color, background, border: `1px solid ${border}` }}>
    <div>{icon}</div><div className="cmd-title">{loading ? "MENGIRIM…" : title}</div><div className="cmd-sub">{sub}</div>
  </button>;
}

function SettingsPage({ account, settings, update, updateLevel, dirty, saving, save, notify, onAddAccount, onDeleteAccount, onRotateKey }) {
  return <section className="section">
    <div className="settings-head"><h2>Pengaturan EA</h2>{dirty && <span className="dirty">Belum disimpan</span>}</div>
    <Panel icon={<Building2 size={16} />} title="Koneksi Akun"><div className="grid">
      <Field label="Account" type="text" value={account.mt5_account} readOnly />
      <Field label="Magic Number" type="text" value={String(account.magic)} readOnly />
      <Field label="Broker" type="text" value={account.broker} readOnly />
      <Field label="Server" type="text" value={account.server} readOnly />
    </div><div style={{ marginTop: 12 }}><Field label="Komentar Order" type="text" value={settings.comment} onChange={(value) => update({ comment: value })} /></div>
    <div className="divider">
      <div className="muted" style={{ fontSize: 12.5, lineHeight: 1.6 }}>
        API key akun ini hanya ditampilkan sekali saat dibuat. Lupa atau curiga
        key ini juga terpasang di terminal MT5 lain? Buat yang baru — key lama
        langsung mati.
      </div>
      <button type="button" className="icon-btn" style={{ width: "auto", padding: "10px", marginTop: 10 }} onClick={onRotateKey}>Buat API Key Baru</button>
    </div>
    <div className="actions" style={{ marginTop: 12 }}>
      <button type="button" className="icon-btn" style={{ width: "auto", flex: 1, padding: "10px" }} onClick={onAddAccount}>+ Tambah Akun Lain</button>
      <button type="button" className="icon-btn" style={{ width: "auto", flex: 1, padding: "10px", color: "var(--red)", borderColor: "#e5484d59" }} onClick={onDeleteAccount}>Hapus Akun Ini</button>
    </div></Panel>
    <Panel title="📊 Grid & Lot"><div className="grid">
      <Field label="Lot Awal" step="0.001" value={settings.baseLot} onChange={(value) => update({ baseLot: value })} />
      <Field label="Penambahan Lot / Layer" step="0.001" value={settings.lotIncrement} onChange={(value) => update({ lotIncrement: value })} />
      <Field label="Jarak Grid (Point)" value={settings.stepPoints} onChange={(value) => update({ stepPoints: value })} />
      <Field label="Maks. Layer / Sisi" step="1" value={settings.maxLayers} onChange={(value) => update({ maxLayers: value })} />
    </div></Panel>
    <Panel title="💰 Take Profit"><div className="grid">
      <Field label="TP per Sisi (USD)" value={settings.tpPerSide} onChange={(value) => update({ tpPerSide: value })} />
      <Field label="TP Total Basket (USD)" value={settings.tpTotal} onChange={(value) => update({ tpTotal: value })} />
    </div><div className="divider"><Toggle label="Gunakan TP Dinamis per Layer" checked={settings.useDynamicTP} onChange={(value) => update({ useDynamicTP: value })} /></div>
    {settings.useDynamicTP && <div className="grid divider">{Object.entries(settings.tpLevels).map(([key, value]) =>
      <Field key={key} label={`Layer ${key}`} value={value} suffix="USD" onChange={(next) => updateLevel(key, next)} />)}</div>}</Panel>
    <Panel title="🛡️ Manajemen Risiko">
      <Toggle label="Gunakan Stop Loss" checked={settings.useStopLoss} onChange={(value) => update({ useStopLoss: value })} />
      {settings.useStopLoss && <div className="divider"><Field label="Stop Loss (Point)" value={settings.slPoints} onChange={(value) => update({ slPoints: value })} /></div>}
      <div className="divider"><Toggle label="Gunakan Target Profit Sesi" checked={settings.useDailyTP} onChange={(value) => update({ useDailyTP: value })} />
      {settings.useDailyTP && <div style={{ marginTop: 10 }}><Field label="Target Profit Sesi (USD)" value={settings.dailyTP} onChange={(value) => update({ dailyTP: value })} />
        {/* Bukan "Harian": EA menghitung profit sejak dirinya start, bukan sejak
            tengah malam. Restart EA, MT5 dimuat ulang, VPS reboot, atau
            AutoTrading dimatikan-nyalakan lagi = hitungan mulai dari nol dan
            target boleh tercapai lagi hari itu juga. Menyebutnya "Harian"
            membuat user mengira ada plafon rugi harian yang tidak ada. */}
        <div className="muted" style={{ marginTop: 8, fontSize: 11.5 }}>
          Dihitung sejak EA start, bukan sejak tengah malam. Restart EA atau
          AutoTrading dimatikan-nyalakan lagi = hitungan kembali ke nol.
        </div></div>}</div>
    </Panel>
    <Panel title="📶 Filter Eksekusi"><div className="grid">
      <Field label="Maks. Spread (Point)" value={settings.maxSpread} onChange={(value) => update({ maxSpread: value })} />
      <Field label="Slippage (Point)" step="1" value={settings.slippage} onChange={(value) => update({ slippage: value })} />
    </div><div style={{ marginTop: 12 }}><Field label="Jeda Minimum Antar Order (detik)" step="1" value={settings.minSecBetweenOps} onChange={(value) => update({ minSecBetweenOps: value })} /></div></Panel>
    <Panel title="🎮 Kontrol Sisi & Auto Start">
      <Toggle label="Izinkan Buy & Sell Bersamaan" checked={settings.allowBothSides} onChange={(value) => update({ allowBothSides: value })} />
      <Toggle label="Izinkan Grid Buy" checked={settings.allowBuy} onChange={(value) => update({ allowBuy: value })} />
      <Toggle label="Izinkan Grid Sell" checked={settings.allowSell} onChange={(value) => update({ allowSell: value })} />
      <div className="divider"><Toggle label="Auto Start Saat EA Dijalankan" checked={settings.autoStart} onChange={(value) => update({ autoStart: value })} />
      {settings.autoStart && <div style={{ marginTop: 10 }}><Field label="Mode Start" type="select" value={settings.startMode} onChange={(value) => update({ startMode: value })}
        options={["START_BOTH", "START_BUY", "START_SELL", "START_NONE"]} /></div>}</div>
    </Panel>
    <div className="actions"><button className="primary" disabled={!dirty || saving} onClick={save}><Save size={16} /> {saving ? "MENYIMPAN…" : "SAVE SETTINGS"}</button>
      <button className="icon-btn" title="Reset draft ke default" onClick={() => {
        update({ ...DEFAULT_SETTINGS, tpLevels: { ...DEFAULT_SETTINGS.tpLevels } });
        notify("Default dimuat sebagai draft; tekan Save untuk menyimpan");
      }}><RotateCcw size={16} /></button></div>
  </section>;
}

function Panel({ icon, title, children }) {
  return <div className="panel"><div className="panel-title">{icon}<h3>{title}</h3></div>{children}</div>;
}

function ProfilePage({ user, accounts, token, onLogout, notify }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const changePassword = async (event) => {
    event.preventDefault(); setError(""); setSuccess("");
    if (newPassword !== confirmPassword) return setError("Konfirmasi password tidak cocok");
    setBusy(true);
    try {
      await api("/auth/change-password", { token, method: "POST", body: { current_password: currentPassword, new_password: newPassword } });
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword(""); setSuccess("Password berhasil diubah"); notify("Password berhasil diubah");
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <section className="section profile-page">
    <div className="settings-head"><div><h2>Profile</h2><div className="muted">Kelola akun Smart Remote EA Assistant Anda</div></div>
      <div className="profile-avatar"><UserRound size={22} /></div></div>
    <Panel icon={<UserRound size={16} />} title="Akun aplikasi">
      <div className="profile-fields">
        <div><div className="field-label">Email</div><div className="profile-value">{user?.email || "Belum tersedia"}</div></div>
        <div><div className="field-label">Verifikasi email</div><div className={`profile-value ${user?.email_verified_at ? "profile-ok" : ""}`}><span className="dot" /> {user?.email_verified_at ? "Sudah diverifikasi" : "Belum diverifikasi"}</div></div>
        <div><div className="field-label">Bergabung sejak</div><div className="profile-value">{user?.created_at ? formatTime(user.created_at) : "Belum tersedia"}</div></div>
      </div>
      <div className="fine">Akun aplikasi ini terpisah dari akun trading MT5.</div>
    </Panel>
    <Panel icon={<Settings2 size={16} />} title="Ubah password">
      <form onSubmit={changePassword}>
        <div className="password-form">
          <Field label="Password saat ini" type="password" value={currentPassword} onChange={setCurrentPassword} autoComplete="current-password" />
          <Field label="Password baru" type="password" value={newPassword} onChange={setNewPassword} autoComplete="new-password" />
          <Field label="Ulangi password baru" type="password" value={confirmPassword} onChange={setConfirmPassword} autoComplete="new-password" />
        </div>
        {error && <div className="notice" role="alert">{error}</div>}
        {success && <div className="notice success" role="status">{success}</div>}
        <button className="primary" disabled={busy || !currentPassword || !newPassword || !confirmPassword}>{busy ? "MENYIMPAN…" : "UBAH PASSWORD"}</button>
      </form>
    </Panel>
    <Panel icon={<Wallet size={16} />} title="Akun MT5 terhubung">
      <div className="profile-account-count">{accounts.length} akun MT5 terhubung</div>
      <div className="muted">Pengelolaan akun MT5, API key, dan pengaturan EA tersedia di Settings.</div>
    </Panel>
    <button className="primary profile-logout" onClick={onLogout}><LogOut size={16} /> Logout</button>
  </section>;
}

function Field({ label, value, onChange, type = "number", step, suffix, readOnly, autoComplete, options }) {
  // Password diketik buta di HP: satu huruf salah baru ketahuan setelah submit
  // ditolak. Tombol intip menutup itu. Selalu mulai tersembunyi — yang terlihat
  // di layar bisa terbaca orang lain, jadi menampilkannya harus tindakan sadar.
  const [revealed, setRevealed] = useState(false);
  const isPassword = type === "password";
  return <label className="field"><div className="field-label">{label}</div><div className="field-wrap">
    {type === "select" ? <div className="select-wrap"><select value={value} onChange={(event) => onChange(event.target.value)}>
      {options.map((option) => <option key={option}>{option}</option>)}</select></div>
      : <input type={isPassword && revealed ? "text" : type} step={step} value={value}
          // Kelasnya, bukan selektor [type=password]: saat diintip type-nya
          // berubah jadi "text", dan padding yang ikut hilang membuat teksnya
          // melompat ke kanan tepat ketika mata sedang membacanya.
          className={isPassword ? "has-reveal" : undefined}
          readOnly={readOnly} autoComplete={autoComplete}
          // Scroll di atas input[type=number] yang sedang fokus mengubah nilainya
          // satu step (Firefox sampai sekarang). Di Lot Awal step-nya 0.001 —
          // perubahan yang terlalu kecil untuk terlihat, cukup besar untuk jadi uang.
          onWheel={(event) => event.currentTarget.blur()}
          onChange={onChange ? (event) => onChange(event.target.value) : undefined} />}
    {isPassword && <button type="button" className="reveal" onClick={() => setRevealed((on) => !on)}
      // type="button" wajib: default-nya "submit", jadi tanpa ini mengintip
      // password justru mengirim form login.
      aria-label={revealed ? "Sembunyikan password" : "Tampilkan password"} aria-pressed={revealed}>
      {revealed ? <EyeOff size={16} /> : <Eye size={16} />}
    </button>}
    {suffix && <span className="suffix">{suffix}</span>}
  </div></label>;
}

function Toggle({ label, checked, onChange }) {
  return <button className="toggle" type="button" aria-pressed={checked} onClick={() => onChange(!checked)}>
    <span>{label}</span><span className={`switch${checked ? " on" : ""}`} />
  </button>;
}

const AD_TYPES = { popup: "Popup", running_text: "Running Text" };
const ALLOWED_BANNER_TYPES = ["image/png", "image/jpeg", "image/webp", "image/gif"];

const emptyAdForm = () => ({
  type: "popup", is_active: true,
  banner_url: "", banner_width: "300", banner_height: "250", link_url: "", delay_seconds: "5",
  text_content: "",
});

function adToApi(form) {
  const body = { type: form.type, is_active: form.is_active };
  if (form.type === "popup") {
    Object.assign(body, {
      banner_url: form.banner_url,
      banner_width: Number(form.banner_width) || null,
      banner_height: Number(form.banner_height) || null,
      link_url: form.link_url || null,
      delay_seconds: Number(form.delay_seconds) || 0,
    });
  } else {
    Object.assign(body, { text_content: form.text_content, link_url: form.link_url || null });
  }
  return body;
}

function AdminDashboard({ token, user, onLogout }) {
  const [tab, setTab] = useState("ads");
  const [toast, setToast] = useState("");
  const notify = (message) => { setToast(message); window.setTimeout(() => setToast(""), 2600); };
  return <div className="workspace">
    <aside className="workspace-rail" aria-label="Navigasi admin">
      <div className="logo"><Brand /></div>
      <nav>
        <button title="Iklan" aria-label="Iklan" aria-pressed={tab === "ads"} onClick={() => setTab("ads")}><Radio size={22} /></button>
        <button title="Pengguna" aria-label="Pengguna" aria-pressed={tab === "users"} onClick={() => setTab("users")}><UserRound size={22} /></button>
      </nav>
      <button className="rail-logout" title="Logout" aria-label="Logout" onClick={onLogout}><LogOut size={20} /></button>
    </aside>
    <main className="workspace-main">
      <header className="workspace-header">
        <div><div className="workspace-eyebrow">SMART REMOTE EA ASSISTANT</div><h1>Admin</h1>
          <p className="muted">Masuk sebagai {user?.email}</p></div>
        <nav className="tabs" aria-label="Halaman admin">
          <Tab active={tab === "ads"} onClick={() => setTab("ads")}>Iklan</Tab>
          <Tab active={tab === "users"} onClick={() => setTab("users")}>Pengguna</Tab>
        </nav>
      </header>
      <div className="workspace-content section">
        {tab === "ads" ? <AdminAdsPanel token={token} notify={notify} /> : <AdminUsersPanel token={token} currentUserId={user?.id} notify={notify} />}
      </div>
    </main>
    {toast && <div className="toast" role="status">{toast}</div>}
  </div>;
}

function DeleteAdConfirm({ busy, onCancel, onConfirm }) {
  return <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onCancel()}>
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="delete-ad-title">
      <h3 id="delete-ad-title">Hapus iklan ini?</h3>
      <p className="muted">Tindakan ini tidak bisa dibatalkan.</p>
      <div className="modal-actions">
        <button className="cancel" onClick={onCancel}>Batal</button>
        <button className="confirm" disabled={busy} onClick={onConfirm}>{busy ? "MENGHAPUS…" : "Ya, hapus"}</button>
      </div>
    </div>
  </div>;
}

function AdminAdsPanel({ token, notify }) {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(emptyAdForm);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const [deleteBusy, setDeleteBusy] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [newRowId, setNewRowId] = useState(null);

  const load = useCallback(() => {
    api("/admin/ads", { token }).then((data) => setAds(data.ads))
      .catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const setField = (key) => (value) => setForm((current) => ({ ...current, [key]: value }));

  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try {
      const { ad } = await api("/admin/ads", { token, method: "POST", body: adToApi(form) });
      setForm(emptyAdForm()); notify("Iklan ditambahkan"); load();
      setNewRowId(ad.id); window.setTimeout(() => setNewRowId(null), 2500);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };

  const toggleActive = async (ad) => {
    try { await api(`/admin/ads/${ad.id}`, { token, method: "PUT", body: { is_active: !ad.is_active } }); load(); }
    catch (err) { notify(`Gagal mengubah status: ${err.message}`); }
  };

  const pickFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true); setError("");
    try {
      const compressed = await compressImage(file);
      const url = await uploadBanner(compressed, token);
      const size = await readImageSize(url);
      setForm((current) => ({ ...current, banner_url: url, banner_width: size.width, banner_height: size.height }));
    } catch (err) { setError(err.message); }
    finally { setUploading(false); }
  };

  const remove = async () => {
    setDeleteBusy(true);
    try { await api(`/admin/ads/${pendingDelete.id}`, { token, method: "DELETE" }); notify("Iklan dihapus"); setPendingDelete(null); load(); }
    catch (err) { notify(`Gagal menghapus: ${err.message}`); }
    finally { setDeleteBusy(false); }
  };

  return <>
    <Panel icon={<Radio size={16} />} title="Tambah iklan baru">
      <form onSubmit={submit}>
        <Field label="Tipe" type="select" value={form.type} onChange={setField("type")}
          options={["popup", "running_text"]} />
        {form.type === "popup" ? <>
          <label className="field"><div className="field-label">Upload banner</div><div className="field-wrap">
            <input type="file" accept={ALLOWED_BANNER_TYPES.join(",")} onChange={pickFile} disabled={uploading} />
          </div></label>
          <p className="muted">
            Rekomendasi ukuran: gambar landscape sekitar 800×600px (rasio 4:3) — popup
            otomatis menyesuaikan ke ~380px di HP dan ~560px di desktop, jadi ukuran ini
            tetap tajam di keduanya. File otomatis dikompres & di-resize sebelum upload,
            dan lebar & tinggi di bawah terisi otomatis.
          </p>
          {uploading && <div className="muted">Mengompres & mengunggah…</div>}
          <Field label="URL Banner" type="text" value={form.banner_url} onChange={setField("banner_url")} />
          <div className="grid">
            <Field label="Lebar (px)" value={form.banner_width} onChange={setField("banner_width")} />
            <Field label="Tinggi (px)" value={form.banner_height} onChange={setField("banner_height")} />
          </div>
          <Field label="Link tujuan" type="text" value={form.link_url} onChange={setField("link_url")} />
          <Field label="Tampil setelah (detik)" value={form.delay_seconds} onChange={setField("delay_seconds")} />
        </> : <>
          <Field label="Teks berjalan" type="text" value={form.text_content} onChange={setField("text_content")} />
          <Field label="Link tujuan (opsional)" type="text" value={form.link_url} onChange={setField("link_url")} />
        </>}
        <div className="divider"><Toggle label="Aktif" checked={form.is_active} onChange={setField("is_active")} /></div>
        {error && <div className="notice" role="alert">{error}</div>}
        <button className="primary" style={{ marginTop: 12 }} disabled={busy}>{busy ? "MENYIMPAN…" : "TAMBAH IKLAN"}</button>
      </form>
    </Panel>

    <Panel icon={<Activity size={16} />} title={`Daftar iklan (${ads.length})`}>
      {loading ? <div className="muted">Memuat…</div>
        : ads.length === 0 ? <div className="muted">Belum ada iklan.</div>
        : ads.map((ad) => <div className={`log-row${ad.id === newRowId ? " new-row" : ""}`} key={ad.id}>
            <div><div className="log-name">{AD_TYPES[ad.type]}{ad.is_active ? "" : " · nonaktif"}</div>
              <div className="log-state">{ad.type === "popup" ? ad.banner_url : ad.text_content}</div></div>
            <div style={{ display: "flex", gap: 8, flex: "none" }}>
              <button className="icon-btn" title={ad.is_active ? "Nonaktifkan" : "Aktifkan"} onClick={() => toggleActive(ad)}>
                {ad.is_active ? <EyeOff size={16} /> : <Eye size={16} />}</button>
              <button className="icon-btn" title="Hapus" onClick={() => setPendingDelete(ad)}><X size={16} /></button>
            </div>
          </div>)}
    </Panel>
    {pendingDelete && <DeleteAdConfirm busy={deleteBusy} onCancel={() => setPendingDelete(null)} onConfirm={remove} />}
  </>;
}

function AdminUsersPanel({ token, currentUserId, notify }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    api("/admin/users", { token }).then((data) => setUsers(data.users))
      .catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, [token]);
  useEffect(() => { load(); }, [load]);

  const toggleActive = async (item) => {
    try {
      await api(`/admin/users/${item.id}`, { token, method: "PUT", body: { is_active: !item.is_active } });
      notify(item.is_active ? "Pengguna dinonaktifkan" : "Pengguna diaktifkan"); load();
    } catch (err) { notify(`Gagal mengubah status: ${err.message}`); }
  };

  return <Panel icon={<UserRound size={16} />} title={`Pengguna (${users.length})`}>
    {error && <div className="notice" role="alert">{error}</div>}
    {loading ? <div className="muted">Memuat…</div>
      : users.map((item) => <div className="log-row" key={item.id}>
          <div><div className="log-name">{item.email}{item.id === currentUserId ? " · Anda" : ""}</div>
            <div className="log-state">{item.role} · {item.account_count} akun MT5{item.is_active ? "" : " · nonaktif"}</div></div>
          <button className="icon-btn" style={{ width: "auto", padding: "0 12px" }} disabled={item.id === currentUserId}
            title={item.is_active ? "Nonaktifkan" : "Aktifkan"} onClick={() => toggleActive(item)}>
            {item.is_active ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>)}
  </Panel>;
}

function Confirm({ command, account, impact, onCancel, onConfirm }) {
  return <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onCancel()}>
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <h3 id="confirm-title">Konfirmasi {command.label}</h3>
      <p className="muted">Perintah trading ini tidak dapat dibatalkan setelah diambil EA.</p>
      <div className="impact">
        <Impact label="Akun" value={`${account.mt5_account} · ${account.broker || account.server}`} />
        <Impact label="Posisi terdampak" value={impact.positions} />
        <Impact label="Floating P/L saat ini" value={impact.profit} />
      </div>
      <div className="modal-actions"><button className="cancel" onClick={onCancel}>Batal</button><button className="confirm" onClick={onConfirm}>Ya, kirim</button></div>
    </div>
  </div>;
}

function Impact({ label, value }) {
  return <div><div className="impact-label">{label}</div><div className="impact-value">{value}</div></div>;
}
